export default {
  "HitPaw Online Audio Extractor": "HitPaw Extractor de Audio Online",
  "Extract sound from videos with ease.": "Extraer el sonido de los videos con facilidad.",
  "Select Audio Format": "Seleccionar formato de audio",
  "Extract Audio": "Extraer audio",
  "Extracting Audio": "Extrayendo audio",
  "Extracted Successfully": "Extraído con éxito",
  "Extract New": "Extraer nuevo",
  "Extraction Failed": "Extracción falló",
  "Format": "Formato",
};
